// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"67db78e1","560":"f92b9755","703":"6083e39a","787":"7f02945f"}[chunkId] + ".chunk.js";
};